import { LocationModel } from './location.model';

export class Session {
  id: number;
  userAgent: string;
  device: string;
  platform: string;
  ip: string;
  location: LocationModel;
  createdAt: string;
  deletedAt: string;

  constructor(input: any = {}) {
    this.id = input.id;
    this.userAgent = input.user_agent;
    this.location = new LocationModel(input.location);
    this.ip = input.ip;
    this.device = input.device;
    this.platform = input.platform;
    this.createdAt = input.created_at;
    this.deletedAt = input.deleted_at;
  }
}
